// src/components/shell/OfflineBanner.tsx
// Thin red banner shown below the TopStrip when the browser reports offline.
// Mirrors the impersonation-banner shape (compact, contrasting) but smaller.
// Copy passes through the verbiage simplification workstream later.
import { useIsOnline } from "@/hooks/useIsOnline";

export function OfflineBanner() {
  const isOnline = useIsOnline();
  if (isOnline) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="w-full bg-red-600 text-white text-[12px] sm:text-xs font-semibold tracking-wide px-4 py-1 text-center shadow-sm"
    >
      You are offline — changes will sync when your connection returns.
    </div>
  );
}
